// src/components/Sidebar.jsx
import React from 'react';
import { NavLink } from 'react-router-dom';
import { 
  FaChartBar, 
  FaRobot, 
  FaPlug, 
  FaUser, 
  FaCreditCard, 
  FaChevronLeft,
  FaChevronRight,
  FaMoon,
  FaSun
} from 'react-icons/fa';
import { useTheme } from '../contexts/ThemeContext';
import './Sidebar.css';

const Sidebar = ({ isOpen, toggleSidebar }) => {
  const { theme, toggleTheme } = useTheme();
  
  return (
    <div className={`sidebar ${isOpen ? 'open' : 'closed'}`}>
      <div className="sidebar-header">
        <h2 className="logo">Notto Bot</h2>
        <button className="toggle-btn" onClick={toggleSidebar}>
          {isOpen ? <FaChevronLeft /> : <FaChevronRight />}
        </button>
      </div>
      
      <nav className="sidebar-nav">
        <ul>
          <li>
            <NavLink to="/dashboard" className={({ isActive }) => isActive ? 'active' : ''}>
              <FaChartBar />
              <span className="nav-text">Dashboard</span>
            </NavLink>
          </li>
          <li>
            <NavLink to="/bots" className={({ isActive }) => isActive ? 'active' : ''}>
              <FaRobot />
              <span className="nav-text">Bots</span>
            </NavLink>
          </li>
          <li>
            <NavLink to="/connections" className={({ isActive }) => isActive ? 'active' : ''}>
              <FaPlug />
              <span className="nav-text">Conexiones</span>
            </NavLink>
          </li>
          <li>
            <NavLink to="/account" className={({ isActive }) => isActive ? 'active' : ''}>
              <FaUser />
              <span className="nav-text">Cuenta</span>
            </NavLink>
          </li>
          <li>
            <NavLink to="/billing" className={({ isActive }) => isActive ? 'active' : ''}>
              <FaCreditCard />
              <span className="nav-text">Facturación</span>
            </NavLink>
          </li>
        </ul>
      </nav>
      
      <div className="sidebar-footer">
        <div className="theme-switch-container">
          <span className="theme-label">{isOpen && (theme === 'dark' ? 'Modo Oscuro' : 'Modo Claro')}</span>
          <button 
            className="theme-switch" 
            onClick={toggleTheme}
            aria-label={`Cambiar a tema ${theme === 'dark' ? 'claro' : 'oscuro'}`}
          >
            {theme === 'dark' ? <FaSun /> : <FaMoon />}
          </button>
        </div>
        <p>Notto Bot v1.0</p>
      </div>
    </div>
  );
};

export default Sidebar;